import Accounting from 'accounting';

export default {
    methods: {
        calculatePercentage(value, divider) {
            return this.unformat(value) / this.unformat(divider) * 100;
        },
        getAmountFromPercentage(value, divider) {
            return this.unformat(value) / 100 * this.unformat(divider);
        },
        getDollarAmount(value, divider) {
            const calculatedValue = this.getAmountFromPercentage(value, divider);
            let result = 0;
            if (!this.isNullCheck(calculatedValue)) {
                result = calculatedValue.toFixed(2) % 1 === 0 ? Math.round(calculatedValue) : calculatedValue.toFixed(2);
            }
            return result;
        },
        getPercentageAmount(value, divider) {
            const calculatedValue = this.calculatePercentage(value, divider);
            return this.isNullCheck(calculatedValue) ? 0 : calculatedValue.toFixed(2);
        },
        unformat(value) {
            return Accounting.unformat(value);
        },
        isNullCheck(number) {
            return isNaN(number) || number === 'Infinity';
        },
    },
};
